var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackwarditem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1663 7.29587V11.1209C31.1663 14.3084 29.8913 15.5834 26.7038 15.5834H22.8788C19.6913 15.5834 18.4163 14.3084 18.4163 11.1209V7.29587C18.4163 4.10837 19.6913 2.83337 22.8788 2.83337H26.7038C29.8913 2.83337 31.1663 4.10837 31.1663 7.29587ZM15.583 22.8792V26.7042C15.583 29.8917 14.308 31.1667 11.1205 31.1667H7.29551C4.10801 31.1667 2.83301 29.8917 2.83301 26.7042V22.8792C2.83301 19.6917 4.10801 18.4167 7.29551 18.4167H11.1205C14.308 18.4167 15.583 19.6917 15.583 22.8792Z",
    stroke: "#315C66",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6213 15.5833V19.295C24.6213 23.1058 23.1054 24.6216 19.2946 24.6216H15.5829V22.8791C15.5829 19.6916 14.3079 18.4166 11.1204 18.4166H9.37793V14.705C9.37793 10.8941 10.8938 9.3783 14.7046 9.3783H18.4163V11.1208C18.4163 14.3083 19.6913 15.5833 22.8788 15.5833H24.6213Z",
    stroke: "#315C66",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwarditem);
export default __webpack_public_path__ + "static/media/backwarditem.dc7d9121ad919d00043f2c8fd28940ce.svg";
export { ForwardRef as ReactComponent };